import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FilterTableHeader from './FilterTableHeader';


class FilterTable extends Component {
  getAdvancedSearchLink = () => {
    const { uuid, query } = this.props.premiumSearch;
    const link = `/advanced-search?case_uuid=${uuid}&query=${query}&do_search=1`;

    return (
      <a href={link} className="advanced-search-link processed">
        Premium Search
      </a>
    );
  }

  getTableFilterHeader = (tableRef) => {
    const advancedSearchLink = (this.props.premiumSearch)
      ? this.getAdvancedSearchLink()
      : null;

    return (
      <div className="live_search">
        <span>Find What: </span>
        <input onChange={this.filterTable.bind(this, tableRef)}
               placeholder="enter search term"
               type="search"
               style={{ width: 250 }} />
        { advancedSearchLink }
      </div>
    );
  }

  filterTable = (tableRef, e) => {
    const context = window.$(this.refs[tableRef]).find('tbody');
    const searchString = e.target.value.toLowerCase();

    if (searchString.length === 0) {
      window.$('tr', context).removeHighlight();
      window.$('tr', context).css('display', '');
    } else {
      window.$('tr', context).each((index, tableRow) => {
        if (window.$(tableRow).text().toLowerCase().indexOf(searchString) > -1) {
          tableRow.style.display = '';
          window.$(tableRow).removeHighlight();
          window.$(tableRow).highlight(searchString);
        } else {
          tableRow.style.display = 'none';
        }
      });
    }
  }

  render() {
    const { Header, headerProps } = this.props;
    const tableRef = 'case-tbody';

    // Header = Header || <FilterTableHeader filterTable={this.filterTable.bind(null, tableref)} />;
    // if (Header === null) {
    //   Header =
    // }
    //
    return (
      <div className="filter-table" ref={tableRef}>
        {/*{ this.getTableFilterHeader(tableRef) }*/}
        <Header filterTable={this.filterTable.bind(null, tableRef)} {...headerProps} />
        { this.props.children }
      </div>
    );
  }
}

FilterTable.defaultProps = {
  className: 'filter-table',
  premiumSearch: null,
  showHeader: true,
  // filterTable: null,
  Header: FilterTableHeader,
  headerProps: {},
};

FilterTable.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  premiumSearch: PropTypes.object,
  showHeader: PropTypes.bool,
  Header: PropTypes.any,
  headerProps: PropTypes.object,
};

export default FilterTable;



/** WEBPACK FOOTER **
 ** ./src/components/common/FilterTable.js
 **/